import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardService implements CanActivate {
  private usuarioLogado = false;
  constructor(
    public authentication: AuthenticationService,
    public router: Router
  ) {
    this.authentication.authNavStatus$.subscribe({
      next: (status) => {
        this.usuarioLogado = status;
      }
    });
  }

  canActivate(): boolean {
    if (this.usuarioLogado) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
